import { Button } from "@sellar-io/components";
import { useForm } from "react-hook-form";
import { v4 } from "uuid";
import { Alert } from "../../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../../hooks/api/v2/apiV2Request";
import { usePriceTierOrderRuleCreate } from "../../../../../hooks/api/v2/priceTierOrderRule/usePriceTierOrderRuleCreate";
import {
  PriceTierOrderRuleForm,
  PriceTierOrderRuleFormValues,
} from "./PriceTierOrderRuleForm";

const formId = v4();

export const PriceTierOrderRuleDialogCreate = ({
  priceTierId,
  orderRulesId,
  active,
  onDismiss,
}: {
  priceTierId: number;
  orderRulesId: number | null;
  active: boolean;
  onDismiss: () => void;
}) => {
  const form = useForm<PriceTierOrderRuleFormValues>({
    shouldUseNativeValidation: true,
  });

  const priceTierOrderRuleCreateMutation = usePriceTierOrderRuleCreate();

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={`Add order rule`}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogContent>
        <PriceTierOrderRuleForm
          key={formId}
          form={form}
          formId={formId}
          onSave={(data) => {
            priceTierOrderRuleCreateMutation.mutate(
              { ...data, PriceTierId: priceTierId, OrderRulesId: orderRulesId },
              {
                onSuccess: () => {
                  onDismiss();
                },
              },
            );
          }}
        />
        {priceTierOrderRuleCreateMutation.isError ? (
          <Alert
            message={
              apiV2AssertError(priceTierOrderRuleCreateMutation.error)?.response
                ?.data.message ?? "Unknown error"
            }
          ></Alert>
        ) : null}
      </DialogContent>
      <DialogCTA>
        <Button
          loading={priceTierOrderRuleCreateMutation.isPending}
          form={formId}
          type={"submit"}
        >
          Add
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
